<div class="dynamic-video-iframe" *ngIf="item">
  <iframe
  frameborder="0"
   width="560"
    [src]="item.video_iframe"
    allow="autoplay; fullscreen; picture-in-picture"
  ></iframe>
</div>
